export default {
  GET_ITEMS(state) {
    return state.abonnements
  },

  GET_ITEM(state, id) {
    return state.abonnements.find(item => item.id == id)
  },
}
